export const isDoNotTrackEnabled = (): boolean => {
  try {
    if (typeof navigator === 'undefined') return false;
    const dnt =
      (navigator as Navigator & { doNotTrack?: string; msDoNotTrack?: string }).doNotTrack ||
      (window as Window & { doNotTrack?: string }).doNotTrack ||
      (navigator as Navigator & { msDoNotTrack?: string }).msDoNotTrack;
    return dnt === '1' || dnt === 'yes';
  } catch {
    return false;
  }
};
